export default [
  {
    title: 'مدیریت دستاوردها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'دستاوردها',
        route: { name: 'honor' },
        resource: 'HonorManager',
        action: 'show',
      },
      {
        title: 'دسته بندی ها',
        route: { name: 'honorcategory' },
        resource: 'HonorCategoryManager',
        action: 'show',
      },
    ],
  },
]
